import React from "react";
import AccordionCard from "../../../../../components/common/PL/AccordionCard/AccordionCard";
import Badge from "../../../../../components/common/PL/Badge/Badge";
import FormDocumentPicturePreview from "../../../../../components/common/PL/PicturePreview/FormDocumentPicturePreview";
import FormPicturePreview from "../../../../../components/common/PL/PicturePreview/FormPicturePreview";
import FormSelect from "../../../../../components/common/PL/Select/FormSelect";
import FormTextInput from "../../../../../components/common/PL/TextInput/FormTextInput";
import { countryListData } from "../../../../../utils/countries";
import {
  validateDocumentNumber,
  validateEmail,
  validatePhone,
} from "../../utils/registroIngresoSchema";
import { computePrevalidationFlagBadges } from "../../utils/prevalidationBadges";
import VisitorPersonalDataFields from "./VisitorPersonalDataFields";
import "./VisitorDataForm.css";

type VisitorDataFormProps = {
  formId: string;
  disabled?: boolean;
  authorizations?: any[];
};

const VisitorDataForm = ({ formId, disabled = false, authorizations }: VisitorDataFormProps) => {
  const countryOptions = React.useMemo(
    () => countryListData.map((country) => ({ value: country.value, label: country.name })),
    []
  );

  const { suspended, accessByGuard } = React.useMemo(
    () => computePrevalidationFlagBadges(authorizations),
    [authorizations]
  );

  return (
    <AccordionCard id={`${formId}-visitor-data`} titleKey="Datos personales" number={1} expanded>
      <div className="visitorDataSectionContainer">
        <div className="visitorDataPhotoWrapper">
          <div>
            <FormPicturePreview
              name="visitorPhoto"
              label="Foto selfie"
              allowImageViewer
              allowClear={!disabled}
              disabled={disabled}
            />
            {(suspended || accessByGuard) && (
              <div className="visitorDataPhotoBadges">
                {suspended && <Badge variant="red" label="Acceso suspendido" />}
                {accessByGuard && <Badge variant="orange" label="Paso previo por portería" />}
              </div>
            )}
          </div>
        </div>

        <div className="visitorDataGrid">
          <FormTextInput
            name="firstName"
            label="Nombre *"
            placeholder="-completar-"
            rules={{ required: "El nombre es obligatorio" }}
            disabled={disabled}
          />

          <FormTextInput
            name="lastName"
            label="Apellido *"
            placeholder="-completar-"
            rules={{ required: "El apellido es obligatorio" }}
            disabled={disabled}
          />

          <FormSelect
            name="documentCountry"
            label="País del documento *"
            placeholder="-completar-"
            options={countryOptions}
            rules={{ required: "El país del documento es obligatorio" }}
            disabled={disabled}
          />

          <FormTextInput
            name="documentNumber"
            label="Número de documento *"
            placeholder="-completar-"
            rules={{ validate: validateDocumentNumber }}
            disabled={disabled}
          />

          <FormTextInput
            name="email"
            label="Mail"
            placeholder="-completar-"
            rules={{
              validate: validateEmail,
            }}
            disabled={disabled}
          />

          <FormTextInput
            name="phone"
            label="Número de celular"
            placeholder="-completar-"
            rules={{
              validate: validatePhone,
            }}
            disabled={disabled}
          />

          <VisitorPersonalDataFields disabled={disabled} />
        </div>

        <div className="visitorDataDocumentsRow">
          <FormDocumentPicturePreview
            allowClear={!disabled}
            allowImageViewer
            name="frontDNI"
            label="Foto DNI frente."
            fileName="Foto DNI frente."
            readOnly={disabled}
          />

          <FormDocumentPicturePreview
            allowClear={!disabled}
            allowImageViewer
            name="backDNI"
            label="Foto DNI dorso."
            fileName="Foto DNI dorso."
            readOnly={disabled}
          />
        </div>
      </div>
    </AccordionCard>
  );
};

export default VisitorDataForm;
